<template>
  <div class="wrap">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/tool/sheet/intro'}">成绩表</el-breadcrumb-item>
        <el-breadcrumb-item>成绩表列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <div class="header">
        <h3>成绩表汇总列表</h3>
        <div class="form">
          <el-input v-model="sheetName" style="width: 240px" size="small" placeholder="搜索成绩表名称" clearable>
            <i slot="append" class="el-icon-search" @click="getSheetData()"></i>
          </el-input>
          <el-button v-if="userInfo.isAdmin" type="primary" size="small" @click="$router.push('/tool/sheet/student')">学生成绩查看</el-button>
          <el-button v-if="userInfo.isAdmin" type="primary" size="small" @click="$router.push('/tool/sheet/newsheet')">新增成绩表</el-button>
        </div>
      </div>

      <div class="main">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-if="userInfo.isAdmin" label="由我创建" name="create">
            <div class="yh-table">
              <el-table :data="examSheetCreateList" highlight-current-row v-loading="examSheetCreateLoading">
                <el-table-column prop="name" label="名称" min-width="330"></el-table-column>
                <el-table-column prop="gradeName" label="年级" align="center"></el-table-column>
                <el-table-column prop="createrName" label="创建人" align="center" min-width="100"></el-table-column>
                <el-table-column prop="created_at" label="创建时间" align="center" min-width="150"></el-table-column>
                <el-table-column prop="state" label="数据更新" align="center" min-width="120">
                  <template slot-scope="scope">
                    <span v-if="scope.row.isRefresh === 0">无</span>
                    <span class="new-data" v-if="scope.row.isRefresh === 1">数据有更新</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="360">
                  <template slot-scope="scope">
                    <ul class="operate">
                      <li v-if="scope.row.academicYear == academicYear" @click="updateSheet(scope.row)">
                        <i class="el-icon-edit"></i>
                        <span>编辑</span>
                      </li>
                      <li v-if="scope.row.academicYear == academicYear" @click="deleteSheet(scope.row)">
                        <i class="el-icon-delete"></i>
                        <span>删除</span>
                      </li>
                      <li v-if="scope.row.academicYear == academicYear" @click="pathToResult(scope.row)">
                        <i class="el-icon-view"></i>
                        <span>查看结果</span>
                      </li>
                      <li @click="showeExportDataModal(scope.row, 'all')">
                        <i class="el-icon-download"></i>
                        <span>导出</span>
                      </li>
                    </ul>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination">
              <!-- @current-change="handleCurrentChange" -->
              <zj-pagination  :page="{current: pagination.current_page, total: pagination.total}"></zj-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="待我上传" name="upload">
            <div class="yh-table">
              <el-table :data="examSheetUploadList" highlight-current-row v-loading="examSheetUploadLoading">
                <el-table-column prop="name" label="名称" min-width="330"></el-table-column>
                <el-table-column prop="gradeName" label="年级" align="center"></el-table-column>
                <el-table-column prop="createrName" label="创建人" align="center" min-width="100"></el-table-column>
                <el-table-column prop="created_at" label="创建时间" align="center" min-width="150"></el-table-column>
                <el-table-column prop="updated_at" label="最新上传时间" align="center" min-width="120"></el-table-column>
                <el-table-column label="操作" align="center" width="180">
                  <template slot-scope="scope">
                    <ul class="operate">
                      <li>
                        <i class="el-icon-view"></i>
                        <span @click="pathToResult(scope.row)">查看结果</span>
                      </li>
                      <li @click="showeExportDataModal(scope.row, '')">
                        <i class="el-icon-download"></i>
                        <span>导出</span>
                      </li>
                    </ul>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination">
              <zj-pagination @current-change="handleUploadCurrentChange" :page="{current: pagination.current_page, total: pagination.total}"></zj-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

    </div>

    <yue-dialog title="导出数据" :visible.sync="isExportDataModal" width="600px" center>
      <div class="export-table">
        <el-table :data="sheet" size="small">
          <el-table-column prop="name" label="成绩表" align="center"></el-table-column>
          <el-table-column prop="isRefresh" label="数据更新" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.isRefresh === 0">无</span>
              <span v-if="scope.row.isRefresh === 1" style="color: #478EFF">数据有更新</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.isGen === 0 && curAcademicYear == academicYear" type="text" size="mini" @click="createDownloadData(scope.row)">生成数据</el-button>
              <el-button v-if="scope.row.isGen === 1 && curAcademicYear == academicYear" type="text" size="mini">正在生成中...</el-button>
              <el-button v-if="scope.row.isGen === 1 && curAcademicYear == academicYear" type="text" size="mini" @click="getSheet(scope.row)">刷新</el-button>
              <el-button v-if="scope.row.isGen === 2 && curAcademicYear == academicYear" type="text" size="mini" @click="createDownloadData(scope.row)">重新生成</el-button>
              <a :href="scope.row.genUrl" download>
                <el-button v-if="scope.row.isGen === 2" type="text" size="mini">下载</el-button>
              </a>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </yue-dialog>
  </div>
</template>

<style scoped lang="scss">
.breadcrumb {
  height: 45px;
  line-height: 45px;
  .el-breadcrumb {
    display: inline-block;
  }
}

.container {
  .header {
    border-radius: 6px 6px 0 0;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    > h3 {
      font-size: 16px;
      font-weight: bold;
    }
    .form {
      ::v-deep .el-input {
        display: inline-block;
        // width: 240px;
        position: relative;
      }
      ::v-deep .el-input-group__append {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        width: 38px;
        padding: 0;
        font-size: 18px;
        line-height: 32px;
        text-align: center;
        background: #fff;
        &:hover {
          color: #478eff;
          cursor: pointer;
        }
      }
      ::v-deep .el-button {
        margin-left: 60px;
        border: 1px solid #478eff;
        background: #478eff;
        box-shadow: 0px 3px 6px rgba(0, 64, 165, 0.3) !important;
      }
    }
  }
  .main {
    ::v-deep .el-tabs__header {
      padding: 0 20px 15px;
      margin-bottom: 0;
      background: #fff;
    }

    .new-data {
      color: #478eff;
    }
    .current-row {
      .new-data {
        color: #fff;
      }
    }

    .pagination {
      padding: 20px 0;
      text-align: right;
    }
  }
  .yh-table ::v-deep {
    .el-table {
      color: #585f6a;
      &::before {
        display: none;
      }
    }
    .el-table .el-table__header .cell {
      color: #9da7b5;
    }
    .el-table td,
    .el-table th.is-leaf {
      border-bottom: none !important;
    }
    .el-table th {
      background: transparent !important;
    }
    .el-table__body {
      border-spacing: 0px 10px;
      background: #f5f5f5;
    }
    .current-row > td {
      color: #fff;
      background: #478eff;
    }

    .el-table__row:not(.current-row):hover > td {
      background: rgba(#478eff, 0.3);
    }

    .el-table__header tr th {
      background: #fff;
      &:nth-child(1) {
        border-bottom-left-radius: 6px;
        text-indent: 5px;
      }
      &:nth-last-child(1) {
        border-bottom-right-radius: 6px;
      }
    }

    .el-table__row td {
      &:nth-child(1) {
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
        text-indent: 10px;
      }
      &:nth-last-child(1) {
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
      }
    }

    .operate {
      > li {
        margin: 6px;
        display: inline-block;
        cursor: pointer;
      }
    }
  }
}
</style>

<script>
import { mapGetters } from 'vuex'
import Util from '@/utils/util'
import { getMySheetCreate, getMySheetUpload, deleteSheet, getSheet, getMySheet, createSheetDownload } from '@/api/tool'
import ZjPagination from '../../zujuan/components/ZjPagination.vue'

export default {
  components: { ZjPagination },
  data () {
    return {
      academicYear: '',
      sheetName: '',
      activeName: 'create',

      isExportDataModal: false,
      sheetLoading: false,
      sheet: [],

      examSheetCreateLoading: false,
      examSheetCreateList: [],
      pagination: {
        current_page: 1,
        total: 0
      },

      examSheetUploadLoading: false,
      examSheetUploadList: [],

      genType: 1,	// 1全部导出（由我创建）  2按权限导出（由我上传）

      curAcademicYear: '',// 当前操作条目
    }
  },

  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo',
      gradeList: 'getGradeList'
    })
  },

  mounted () {
    this.academicYear = this.userInfo.academicYear;

    if (this.userInfo.isAdmin) {
      this.activeName = 'create'
    } else {
      this.activeName = 'upload'
    }
    this.getSheetData()
  },
  watch: {
    activeName () {
      this.pagination.current_page = 1
      this.getSheetData()
    }
  },
  methods: {

    getSheetData () {
      if (this.activeName === 'create') {
        this.getMySheetCreate()
      } else {
        this.getMySheetUpload()
      }
    },

    // 导出数据
    showeExportDataModal (row, type) {
      this.curAcademicYear = row.academicYear

      this.genType = type === 'all' ? 1 : 2
      this.sheet = []
      this.isExportDataModal = true
      this.getSheet(row)
    },

    async getSheet (row) {
      this.sheetLoading = true
      let params = {
        templateId: row.id
      }
      let res

      if (this.genType === 1) {
        res = await getSheet(params)
      } else {
        params.userId = this.userInfo.userId
        res = await getMySheet(params)
      }
      this.sheetLoading = false

      if (res.code === 200) {
        if (this.genType === 1) {
          this.sheet = [res.result]

        } else {
          let sheet = res.result[0]

          sheet.name = sheet.templateName
          sheet.isRefresh = sheet.is_refresh
          sheet.id = sheet.templateId

          this.sheet = [sheet]
        }

      } else {
        this.$message.error(res.message)
      }
    },

    async createDownloadData (row) {
      let params = {
        genType: this.genType,
        templateId: row.id,
        userId: this.userInfo.userId,
      }

      let res = await createSheetDownload(params)

      if (res.code === 200) {
        this.getSheet(row)
      } else {
        this.$message.error(res.message)
      }
    },

    // 详情页
    pathToResult (row) {
      this.$router.push(`/tool/sheet/detail?id=${row.id}&gradeId=${row.gradeId}&name=${row.name}`)
    },

    updateSheet (row) {
      this.$router.push('/tool/sheet/addsubject?templateId=' + row.id + '&gradeId=' + row.gradeId + '&update=1' + '&name=' + row.name)
    },

    async deleteSheet (row) {
      try {
        let r = await this.$confirm("确定要删除该成绩表吗？", "提示", {
          type: "warning"
        })

        let res = await deleteSheet({ templateId: row.id })
        if (res.code === 200) {
          this.$message.success(res.message)

          if (this.activeName === 'create') {
            this.getMySheetCreate()
          } else {
            this.getMySheetUpload()
          }
        } else {
          this.$message.error(res.message)
        }

      } catch (e) {

      }
    },

    _getGradeName (gradeNum) {
      let grade = this.gradeList.find(item => item.gradeNum === gradeNum)
      return grade ? grade.gradeName : ''
    },

    async getMySheetCreate () {
      let params = {
        schoolId: this.userInfo.schoolId,
        userId: this.userInfo.userId,
        templateName: this.sheetName,
        pageNo: this.pagination.current_page,
        pageSize: 10
      }

      this.examSheetCreateLoading = true
      let res = await getMySheetCreate(params)
      this.examSheetCreateLoading = false

      if (res.code === 200) {
        for (let item of res.result) {
          item.gradeName = this._getGradeName(item.gradeNo)
          item.created_at = Util.formatDate(item.createTime, 'ymdhi')
        }
        this.examSheetCreateList = res.result
        this.pagination.total = res.total
      } else {
        this.$message.error(res.message)
      }
    },

    async getMySheetUpload () {
      let params = {
        schoolId: this.userInfo.schoolId,
        userId: this.userInfo.userId,
        templateName: this.sheetName,
        pageNo: this.pagination.current_page,
        pageSize: 10
      }

      this.examSheetUploadLoading = true
      let res = await getMySheetUpload(params)
      this.examSheetUploadLoading = false

      if (res.code === 200) {
        for (let item of res.result) {
          item.gradeName = this._getGradeName(item.gradeNo)
          item.created_at = Util.formatDate(item.createTime, 'ymdhi')
          item.updated_at = Util.formatDate(item.updateTime, 'ymdhi')
        }
        this.examSheetUploadList = res.result
        this.pagination.total = res.total

      } else {
        this.$message.error(res.message)
      }
    },


    handleClick (tab, event) {

    },

    handleCreateCurrentChange (val) {
      this.pagination.current_page = val
      this.getSheetData()
    },

    handleUploadCurrentChange (val) {
      this.pagination.current_page = val
      this.getSheetData()
    }
  }
}
</script>